import {HttpContextToken} from '@angular/common/http';

/** When true, {@link authInterceptor} must not attach `X-Workspace-Id`. */
export const SKIP_WORKSPACE_HEADER = new HttpContextToken<boolean>(() => false);
